import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { Action } from '../../actions';
import { cancelCellEdit } from '../../actions/grid-screen';
import { updatePhraseBidRemote } from '../../actions/phrases-grid';
import {
    PhraseMoneyCellEditor,
    PhraseMoneyCellEditorProps,
    PhraseMoneyCellEditorTypes
} from '../../components/PhraseMoneyCellEditor/PhraseMoneyCellEditor';
import { TrafaretPhrasePriceEditorPopupSaveValue } from '../../components/TrafaretPhrasePriceEditorPopup/TrafaretPhrasePriceEditorPopup';
import { selectGridSourceParams } from '../../selectors/gridSourceParams/gridSourceParams';
import { getEditCellData } from '../../service/GridHelpers/GridHelpers';
import { ConstData } from '../../typings/constants';
import { TrafficVolumeDataItem } from '../../typings/domain';
import { State } from '../../typings/state';

export type StateProps = Pick<PhraseMoneyCellEditorProps, 'isSaving' | 'error' | 'priceLimit' | 'isGridScrolling'>;

export interface DispatchProps {
    onSave: (value: TrafaretPhrasePriceEditorPopupSaveValue) => void;
    onCancel: () => void;
}

export type OwnProps = {
    id: string;
    groupId: string;
    cellName: string;
    currency: string;
    bid?: number;
    trafficVolumeData: Array<TrafficVolumeDataItem>;
    constants: ConstData;
    cls?: string;
};

const mapStateToProps = (state: State, ownProps: OwnProps): StateProps => {
    const { editCellsData, isGridScrolling } = state.grid;
    const { id, cellName, constants, currency } = ownProps;
    const { view } = selectGridSourceParams(state);

    return {
        priceLimit: constants.currencyConstants[currency],
        isGridScrolling,
        ...getEditCellData(editCellsData, id, cellName, view)
    };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>, ownProps: OwnProps): DispatchProps => {
    const { cellName, id, groupId } = ownProps;

    return {
        onSave: (value: TrafaretPhrasePriceEditorPopupSaveValue) => {
            dispatch(
                updatePhraseBidRemote(
                    {
                        id,
                        groupId,
                        exactPriceSearch: value.bid
                    },
                    cellName
                )
            );
        },
        onCancel: () => {
            dispatch(cancelCellEdit(id, cellName));
        }
    };
};

const mergeProps = (
    stateProps: StateProps,
    dispatchProps: DispatchProps,
    ownProps: OwnProps
): PhraseMoneyCellEditorProps => {
    const { currency, bid, trafficVolumeData, cls } = ownProps;

    return {
        ...{ currency, bid, trafficVolumeData, cls },
        ...stateProps,
        ...dispatchProps,
        type: PhraseMoneyCellEditorTypes.trafaretAuction
    };
};

export const PhraseMoneyCellTrafaretAuctionEditorContainer = connect<
    StateProps,
    DispatchProps,
    OwnProps,
    PhraseMoneyCellEditorProps
>(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(PhraseMoneyCellEditor);
